// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import eyeOffIcon from "@/assets/icons/eye-off.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type EyeOffIconProps = Omit<IconProps, "name">;

export function EyeOffIcon(props: EyeOffIconProps): React.ReactNode {
  return <Icon name={eyeOffIcon} {...props} />;
}
